<template>
  <div id="popup-detail">
      <transition name="modal" v-if="isActive">
          <div class="modal-mask">
              <div class="modal-wrapper">
                  <div class="modal-container">
                      <div class="modal-content">
                        <div class="content-body">
                            <div class="logo">
                                <img src="https://ik.imagekit.io/zlt25mb52fx/ahmcdn/uploads/page/banner/logo-jalur-tawa-1-17062025-054246.webp" alt="Logo Jalur Tawa">
                            </div>
                            <h2>Ketentuan Acara</h2>
                            <div class="desc">
                              <h5>Hai BradSis,</h5>
                              <p>Buat yang mau ikutan touring Jalur Tawa, pastiin dulu BradSis penuhi syarat-syarat ini ya:</p>
                              <ol>
                                <li>Minimal usia peserta 17 tahun dan punya SIM motor yang masih aktif.</li>
                                <li>Bawa lengkap semua surat kendaraan: STNK & SIM wajib dibawa, BradSis.</li>
                                <li>Motor apa aja boleh ikut, semua brand welcome! Motor wajib dalam kondisi oke.</li>
                                <li>Touring start dari Jakarta menuju ke Bandung.</li>
                                <li>Biaya ikut GRATIS!</li>
                                <li>
                                  Bradsis bakal dapat:
                                  <ul>
                                    <li>Asuransi selama acara biar aman</li>
                                    <li>Voucher e-money Pertamina senilai Rp150.000,-</li>
                                    <li>Voucher AHASS senilai Rp250.000,-</li>
                                    <li>Nginep 1 malam di Camping Ground Tangkal Pinus</li>
                                    <li>3x makan plus snack biar gak kelaparan</li>
                                  </ul>
                                </li>
                              </ol>
                            </div>

                            <h2>Peraturan Acara</h2>
                            <div class="rule-desc">
                              <ul>
                                <li>Peserta dilarang membawa pasangan atau anak selama touring, supaya fokus bareng BradSis lainnya.</li>
                                <li> Peserta wajib bawa riding gear lengkap sendiri, ya! Helm SNI, jaket, celana panjang, sama sepatu biar safety banget.</li>
                              </ul>
                            </div>

                            <p>Panitia berhak mendiskualifikasi peserta yang melanggar aturan atau membahayakan keselamatan</p>

                            <div class="btn-selesai">
                                <button @click="close" type="button" class="btn btn-red">Setuju</button>
                            </div>
                        </div>

                      </div>
                  </div>
              </div>
          </div>
      </transition>
  </div>
</template>

<script>
export default {
    props: ['slide'],
    data() {
        return {
            isActive: false,
            main_site_url: main_site_url,
            media: null
        }
    },
    methods: {
        show(data){
            this.isActive = !this.isActive;
            this.media = data;
        },
        close(){
            this.isActive = !this.isActive;
        }
    },
}
</script>

<style lang="scss" scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-y: auto;
    padding: 50px 130px;
}

.modal-wrapper {
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    // max-width: 768px;
}

.modal-container {
    width: 80%;
    // background-color: #fff;
    border-radius: 10px;
    // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
    position: relative;
    max-height: none;
    padding: 24px 60px;
    box-sizing: border-box;
}

.modal-header h3 {
    margin-top: 0;
    border-bottom: none;
}

.modal-body {
    margin: 20px 0;
}

.modal-default-button {
    right: -18px;
    top: -18px;
    cursor: pointer;
    background: #E61B33;
    display: block;
    width: 36px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    color: #fff;
    border-radius: 100px;
    position: absolute;
    cursor: pointer;
    span {
        font-size: 20px;
    }
}
.modal-default-button:hover{
    background: #000000;
}
.modal-content{
//   overflow-y: auto;
//   max-height: 80vh;
  padding: 50px;
  background: #fff;
  border: none;

  .logo {
    margin-bottom: 20px;
    text-align: center;

    img {
      width: 178px;
    }
  }

  h3 {
    margin: 0;
    margin-top: 20px;
    margin-bottom: 20px;
    color: #000000;
  }

  .content-body {
    max-height: none;
    overflow: unset;
    padding: 0;

    h2 {
        color: #E41A2B;
    }

    p {
        color: #000000;
    }

    .desc {
        margin-bottom: 26px;
        color: #000000;

        p {
            color: #000000;
        }

        ul {
            list-style-type: disc;
        }

        ul li {
            list-style-type: disc;
        }
    }

    .rule-desc {
        margin-bottom: 20px;
        color: #000;

        ul {
            list-style-type: disc !important;
            list-style: inside !important;
        }

        ul li {
            list-style-type: disc !important;
            list-style: inside !important;
        }
    }
  }

  .btn-selesai {
    display: flex;
    justify-content: center;
  }
}

/*
* The following styles are auto-applied to elements with
* transition="modal" when their visibility is toggled
* by Vue.js.
*
* You can easily play with the modal transition by editing
* these styles.
*/

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
-webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.wrap-box, .wrap-box-thumb {
    border: 1px solid #DBDBDB;
    border-radius: 10px;
    position: relative;
    box-sizing: border-box;
    .wrap-content {
        padding: 20px;
        display: flex;
        justify-content: center;
        .show-img img {
            width: 100%;
        }
    }
}
.wrap-content-thumb {
    padding: 10px;
    display: flex;
    justify-content: center;
    cursor: pointer;
}

.isActive {
    border: 1px solid #E61B33;
    border-radius: 10px;
    position: relative;
    box-sizing: border-box;
}
// ==================================================  MOBILE RESPONSIVE
@media (max-width: 1024px){
    .modal-mask {
        padding: 50px;
    }
    .modal-container{
        width: 100%;
        padding: 15px;
    }

    .modal-content {
        padding: 20px;
    }
}
@media (max-width: 768px){
    .modal-container{
        padding: 15px;
            iframe{
                height: 300px;
            }
    }

    .modal-content {
        // max-height: 100vh;
        padding: 12px;

        .content-body {
            padding: 0 8px;
        }
    }
}

@media (max-width: 576px) {
    .modal-mask {
        padding: 18px;
    }
    .modal-content {
        // max-height: 100vh;
        padding: 12px 8px;

        .logo {
            margin-bottom: 6px;
            img {
                width: 150px;
            }
        }
        .content-body {
            h2 {
                font-size: 1.5rem;
            }

            p {
                font-size: 12px;
            }

            .desc {
                h5 {
                    font-size: 1rem;
                }

                p {
                    font-size: 12px;
                }

                ol {
                    font-size: 12px;
                }
            }

            .rule-desc {
                ul {
                    font-size: 12px;
                }
            }
        }
    }
}
</style>